// import FetchRequest from "@/api/FetchRequest";

// interface loginBody {
//   username: string;
//   password: string;
//   code: string;
//   uuid: string;
// }
// // 登录方法
// export const login = (
//   username: string,
//   password: string,
//   code: string,
//   uuid: string
// ) => {
//   const data: loginBody = {
//     username,
//     password,
//     code,
//     uuid,
//   };
//   return FetchRequest.post("/login", JSON.stringify(data), false);
// };

// // 注册方法
// export const register = (data: any) =>
//   FetchRequest.post("/register", JSON.stringify(data), false);

// // 退出方法
// export const logout = () => FetchRequest.post("/logout", "", true);

// // 获取验证码
// export const getCodeImg = () => FetchRequest.get("/captchaImage", false);

// // 校验账号是否注册
// export const checkIphon = (account:string) => FetchRequest.get("/checkUserUnique"+"?account="+account, false);
// // 获取手机验证码
// export const getsmsCode = (data: any) => FetchRequest.post("/send-sms-code",JSON.stringify(data), false);
// // 验证码登录
// export const loginsmsCode = (data: any) => FetchRequest.post("/sms-login",JSON.stringify(data), false);
// // 微信登录
// export const loginWx = (code:string,state:string) => FetchRequest.get("/wx-login"+"?code="+code+'&state='+state, false);
// // 微信绑定手机号
// export const loginWxmobile = (mobile:string,smsCode:string) => FetchRequest.get("/api/sys/users/bind—mobile"+"?mobile="+mobile+'&smsCode='+smsCode, true);

//=======================接入数字人账户管理相关接口============================== //
import FetchRequestHuman from "@/api/FetchRequestHuman";
interface loginBody {
  username: string;
  password: string;
  // code: string;
  // uuid: string;
}
// 登录方法
export const login = (
  username: string,
  password: string,
  // code: string,
  // uuid: string
) => {
  const data: loginBody = {
    username,
    password,
    // code,
    // uuid,
  };
  return FetchRequestHuman.post("/pc-api/digital-human/auth/login", JSON.stringify(data), false);
};

// 注册方法
export const register = (data: any) =>
FetchRequestHuman.post("/register", JSON.stringify(data), false);

// 退出方法
export const logout = () => FetchRequestHuman.post("/pc-api/digital-human/auth/logout", "", true);

// 获取验证码
export const getCodeImg = () => FetchRequestHuman.get("/captchaImage", false);

// 校验账号是否注册
export const checkIphon = (account:string) => FetchRequestHuman.get("/checkUserUnique"+"?account="+account, false);
// 获取手机验证码
export const getsmsCode = (data: any) => FetchRequestHuman.post("/pc-api/digital-human/auth/send-sms-code",JSON.stringify(data), false);
// 验证码登录
export const loginsmsCode = (data: any) => FetchRequestHuman.post("/pc-api/digital-human/auth/sms-login",JSON.stringify(data), false);
// 微信登录
export const loginWx = (code:string,state:string) => FetchRequestHuman.get("/wx-login"+"?code="+code+'&state='+state, false);
// 微信绑定手机号
export const loginWxmobile = (mobile:string,smsCode:string) => FetchRequestHuman.get("/api/sys/users/bind—mobile"+"?mobile="+mobile+'&smsCode='+smsCode, true);
// 用户信息
export const currentUser = () => FetchRequestHuman.get("/pc-api/digital-human/user/info", true);
// 修改基本信息 update
export const updateUser = (data: any) => FetchRequestHuman.put("/pc-api/digital-human/user/update", JSON.stringify(data),true);
// 修改用户密码
export const updatePassword = (data: any) => FetchRequestHuman.put("/pc-api/digital-human/user/update-password", JSON.stringify(data),true);